
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { MoreVertical, Edit, Plus, Trash2, Download } from "lucide-react";
import { Tables } from "@/integrations/supabase/types";
import { useState } from "react";
import QuoteDeleteDialog from "./QuoteDeleteDialog";

type Quote = Tables<'quotes'>;

interface QuoteActionsDropdownProps {
  quote: Quote;
  isAdmin: boolean;
  onReviseQuote?: (quote: Quote) => void;
  onAddVariation?: (quote: Quote) => void;
  onDeleteQuote: (quoteId: string) => void;
  hasDownload?: boolean;
  onDownload?: () => void;
}

const QuoteActionsDropdown = ({
  quote,
  isAdmin,
  onReviseQuote,
  onAddVariation,
  onDeleteQuote,
  hasDownload = false,
  onDownload
}: QuoteActionsDropdownProps) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  if (!isAdmin) {
    return null;
  }

  const handleDeleteClick = () => {
    setShowDeleteDialog(true);
  };

  const handleDeleteConfirm = () => {
    onDeleteQuote(quote.id);
    setShowDeleteDialog(false);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm">
            <MoreVertical className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {hasDownload && onDownload && (
            <DropdownMenuItem onClick={onDownload}>
              <Download className="w-4 h-4 mr-2" />
              Download
            </DropdownMenuItem>
          )}
          {onReviseQuote && (
            <DropdownMenuItem onClick={() => onReviseQuote(quote)}>
              <Edit className="w-4 h-4 mr-2" />
              Revise Quote
            </DropdownMenuItem>
          )}
          {onAddVariation && (
            <DropdownMenuItem onClick={() => onAddVariation(quote)}>
              <Plus className="w-4 h-4 mr-2" />
              Add Variation
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onClick={handleDeleteClick} className="text-red-600">
            <Trash2 className="w-4 h-4 mr-2" />
            Delete Quote
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <QuoteDeleteDialog
        isOpen={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
        onConfirm={handleDeleteConfirm}
      />
    </>
  );
};

export default QuoteActionsDropdown;
